import request from './request'
import * as http from '@/libs/http'

/**
 * ユーザの支払方法を削除する
 *
 * @param {Number} uid ユーザID
 * @param {Number} payid 支払方法ID
 * @returns {Response} レスポンスデータ
 */
export function removeUserPayment (uid, payid) {
  return request.delete(`/users/${uid}/payments/${payid}`, {
    validateStatus: (status) => [
      http.OK
    ].includes(status)
  })
}
